import React from 'react'
import { getStaticImage } from 'utils/statics'

const ButtonPlus = ({ onClick, altText }) => {
  return (
    <button className='inchat-menu__icon-btn' onClick={onClick}>
      <figure>
        <img
          src={getStaticImage('/icons/orange-brand/icon-add-solid.svg')}
          alt={altText}
        />
      </figure>
    </button>
  )
}

export default ButtonPlus